export default "__VITE_ASSET__DdkAtv5X__"